module.exports = __webpack_public_path__ + "img/noIcon.07b80a2c.svg";